/* ============================================================================
   LAH — BOTAO FLUTUANTE "ESCOLHER LENTES E COMPRAR" NO DESKTOP (Claude 17.0)

   O mesmo papel do dock do celular (lah-purchase-dock): quando o botao do
   painel sai da tela POR CIMA (o cliente rolou para as secoes abaixo, como o
   Custo por uso), aparece um botao no centro da tela, embaixo, na mesma
   altura do balao do chat Tidio. Some quando o botao do painel volta.

   O clique so aciona o botao original (.openProductLens): o fluxo de lentes,
   variantes e rastreamento continua o mesmo.

   Capsula de vidro leitoso (como o painel): nome do produto, preco e, quando
   ha desconto, o preco riscado e o selo "% OFF" (mesmo vermelho #B4341F do
   painel e do dock do celular). Os valores sao lidos do proprio painel e
   acompanham a troca de cor (o Alpine reescreve o preco; um observador
   repete a leitura).

   Altura: medida no iframe do balao da Tidio (#tidio-chat-iframe) quando ele
   esta fechado (pequeno). Sem Tidio na pagina, fica a 24px do pe da tela.
   Esconde com o configurador de lentes aberto (body.hidden-scroll) e com o
   zoom de fotos aberto (html.lah-zoom-trava). Celular nao muda.
   ============================================================================ */
(function () {
    'use strict';

    if (window.__lahDockDesktop) return;
    window.__lahDockDesktop = true;

    var mq = window.matchMedia('(min-width: 1000px)');
    var BASE = 24;           /* px do pe da tela, sem Tidio */

    var dock = null, botao = null, origem = null, io = null, passou = false;

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca quebra a pagina */ }
    }

    function estilos() {
        if (document.getElementById('lah-dock-d-css')) return;
        var st = document.createElement('style');
        st.id = 'lah-dock-d-css';
        st.textContent =
            '.lah-dock-d { display: none; }' +
            '@media (min-width: 1000px) {' +
            '.lah-dock-d { display: block; position: fixed; left: 50%; bottom: var(--lah-dock-d-bottom, 24px); z-index: 2147482000; transform: translate(-50%, 16px); opacity: 0; pointer-events: none; transition: opacity 0.25s ease, transform 0.25s ease; }' +
            '.lah-dock-d.is-visivel { opacity: 1; transform: translate(-50%, 0); pointer-events: auto; }' +
            'body.hidden-scroll .lah-dock-d, html.lah-zoom-trava .lah-dock-d { opacity: 0 !important; pointer-events: none !important; }' +
            '.lah-dock-d__in { position: relative; display: flex; align-items: center; gap: 14px; padding: 5px 5px 5px 18px; border-radius: 999px; background: rgba(255, 255, 255, 0.72); -webkit-backdrop-filter: blur(22px) saturate(1.4); backdrop-filter: blur(22px) saturate(1.4); box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.85), 0 10px 30px rgba(33, 65, 50, 0.14); }' +
            '.lah-dock-d__info { display: flex; flex-direction: column; gap: 2px; min-width: 0; max-width: 220px; font-family: \'Magazine Grotesque\', Helvetica, Arial, sans-serif; }' +
            '.lah-dock-d__titulo { display: flex; align-items: center; gap: 6px; min-width: 0; }' +
            '.lah-dock-d__nome { font-size: 12px; font-weight: 500; line-height: 1.2; color: #1C1C1C; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0; }' +
            '.lah-dock-d__selo { flex: none; padding: 1px 6px; border-radius: 999px; background: #FBE9E6; color: #B4341F; font-size: 9px; font-weight: 600; line-height: 1.35; white-space: nowrap; }' +
            '.lah-dock-d__precos { display: flex; align-items: baseline; gap: 6px; white-space: nowrap; }' +
            '.lah-dock-d__preco { font-size: 13.5px; font-weight: 600; line-height: 1.2; color: #112A1F; }' +
            '.lah-dock-d.tem-desconto .lah-dock-d__preco { color: #B4341F; }' +
            '.lah-dock-d__de { font-size: 11px; line-height: 1.2; color: #8A8A8A; text-decoration: line-through; }' +
            '.lah-dock-d__selo[hidden], .lah-dock-d__de[hidden], .lah-dock-d__info[hidden] { display: none; }' +
            '.lah-dock-d__btn { flex: none; display: inline-flex; align-items: center; justify-content: center; height: 38px; padding: 0 20px; border: 0; border-radius: 999px; background: linear-gradient(180deg, #2A2A2A, #000000); color: #FFFFFF; font: 500 11.5px/1 Helvetica, Arial, sans-serif; letter-spacing: 0.07em; text-transform: uppercase; white-space: nowrap; cursor: pointer; box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18), 0 6px 16px rgba(0, 0, 0, 0.18); transition: transform 0.2s ease, box-shadow 0.2s ease; }' +
            '.lah-dock-d__btn:hover { transform: translateY(-1px); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18), 0 8px 22px rgba(0, 0, 0, 0.22); }' +
            '.lah-dock-d__btn:focus-visible { outline: 2px solid #214132; outline-offset: 3px; }' +
            '}' +
            '@media (prefers-reduced-motion: reduce) { .lah-dock-d, .lah-dock-d__btn { transition: none; } }';
        document.head.appendChild(st);
    }

    /* altura do centro do balao da Tidio (fechado) -> bottom do botao */
    function alinharTidio() {
        if (!dock) return;
        var bottom = BASE;
        var t = document.getElementById('tidio-chat-iframe');
        if (t) {
            var r = t.getBoundingClientRect();
            if (r.height > 20 && r.height < 200 && r.bottom > 0) {
                var centro = r.top + r.height / 2;
                var alt = dock.offsetHeight || 48;
                bottom = Math.max(8, Math.round(window.innerHeight - centro - alt / 2));
            }
        }
        var v = bottom + 'px';
        if (dock.style.getPropertyValue('--lah-dock-d-bottom') !== v) dock.style.setProperty('--lah-dock-d-bottom', v);
    }

    function montar() {
        estilos();
        dock = document.createElement('div');
        dock.className = 'lah-dock-d';
        dock.setAttribute('aria-hidden', 'true');
        dock.innerHTML =
            '<div class="lah-dock-d__in">' +
                '<div class="lah-dock-d__info">' +
                    '<div class="lah-dock-d__titulo"><span class="lah-dock-d__nome"></span><span class="lah-dock-d__selo" hidden></span></div>' +
                    '<div class="lah-dock-d__precos"><span class="lah-dock-d__preco"></span><span class="lah-dock-d__de" hidden></span></div>' +
                '</div>' +
            '</div>';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lah-dock-d__btn';
        b.tabIndex = -1;
        b.textContent = 'Escolher lentes e comprar';
        b.addEventListener('click', function () {
            track('pdp_dock_desktop_click', {});
            window.__lahLensSource = 'dock_desktop';
            var o = document.querySelector('.openProductLens');
            if (o) o.click();
        });
        dock.querySelector('.lah-dock-d__in').appendChild(b);
        document.body.appendChild(dock);
        botao = b;
        ler();
    }

    /* ---------- nome, preco e desconto, lidos do painel ---------- */
    function texto(el) {
        return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function valor(t) {
        var n = String(t || '').replace(/[^\d,]/g, '').replace(',', '.');
        var v = parseFloat(n);
        return isNaN(v) ? 0 : v;
    }

    function visivel(el) {
        return !!el && el.style.display !== 'none' && getComputedStyle(el).display !== 'none';
    }

    function ler() {
        if (!dock) return;
        var painel = document.querySelector('.custom-product-infos') || document;
        var nome = texto(painel.querySelector('.custom-product-title'));
        var precoEl = painel.querySelector('.custom-product-price .price--large');
        var deEl = painel.querySelector('.custom-product-price .price--compare');
        var preco = texto(precoEl);
        var de = visivel(deEl) ? texto(deEl).replace(/\s+[A-Z]{3}$/, '') : '';
        var pct = 0;
        if (de && valor(de) > valor(preco) && valor(preco) > 0) pct = Math.round((1 - valor(preco) / valor(de)) * 100);

        var info = dock.querySelector('.lah-dock-d__info');
        info.hidden = !nome && !preco;
        dock.querySelector('.lah-dock-d__nome').textContent = nome;
        dock.querySelector('.lah-dock-d__preco').textContent = preco;

        var deDock = dock.querySelector('.lah-dock-d__de');
        var selo = dock.querySelector('.lah-dock-d__selo');
        deDock.textContent = pct > 0 ? de : '';
        deDock.hidden = !(pct > 0);
        selo.textContent = pct > 0 ? pct + '% OFF' : '';
        selo.hidden = !(pct > 0);
        dock.classList.toggle('tem-desconto', pct > 0);
    }

    function vigiarPreco() {
        var alvo = document.querySelector('.custom-product-infos');
        if (!alvo || !window.MutationObserver) return;
        var pend = false;
        new MutationObserver(function () {
            if (pend) return;
            pend = true;
            requestAnimationFrame(function () { pend = false; ler(); });
        }).observe(alvo, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
    }

    function mostrar(sim) {
        if (!dock) return;
        sim = sim && mq.matches;
        if (sim) { ler(); alinharTidio(); }
        if (dock.classList.contains('is-visivel') === sim) return;
        dock.classList.toggle('is-visivel', sim);
        dock.setAttribute('aria-hidden', sim ? 'false' : 'true');
        botao.tabIndex = sim ? 0 : -1;
        if (sim) track('pdp_dock_desktop_exibido', {});
    }

    function iniciar() {
        origem = document.querySelector('.openProductLens');
        if (!origem || !window.IntersectionObserver) return;

        montar();
        vigiarPreco();

        /* so aparece depois que o botao do painel passa por CIMA da tela */
        io = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (en) {
                passou = !en.isIntersecting && en.boundingClientRect.top < 0;
                mostrar(passou);
            });
        }, { threshold: 0 });
        io.observe(origem);

        var pend = false;
        window.addEventListener('resize', function () {
            if (pend) return;
            pend = true;
            requestAnimationFrame(function () { pend = false; mostrar(passou); });
        }, { passive: true });

        /* a Tidio carrega depois: realinha quando ela fica pronta */
        document.addEventListener('tidioChat-ready', function () { setTimeout(alinharTidio, 300); });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }
})();
